import React, { memo } from 'react';

import styles from './DefaultLogin.module.less';
import Default from '../../../static/order_lack.svg';

export default memo(() => {
  const handelLogin = () => {
    window && window.CallNativeMethod && window.CallNativeMethod('login');
  };

  return (
    <div className={styles.default}>
      <div>
        <img src={Default} />
      </div>
      <div className={styles.describe}>
        <span>登录后，查看我的订单</span>
        <span className={styles.jump_other} onClick={handelLogin}>
          立即登录
        </span>
      </div>
    </div>
  );
});
